<template
  ><div>
    <v-layout>
      <v-btn
        v-if="displayInfo === true"
        class="ma-0"
        icon
        @click.stop="listBtn = !listBtn"
      >
        <v-icon>list</v-icon>
      </v-btn>

      <v-flex v-if="listBtn === true" xs6 sm5 md3 lg2>
        <v-navigation-drawer v-model="listBtn" hide-overlay>
          <div style="overflow-y: scroll; height: 100vh">
            <!-- <v-card>
              <v-text-field
                class="mx-3"
                flat
                label="Search"
                prepend-inner-icon="search"
                @click:clear="clearSearch"
                v-model="search"
                clearable
              ></v-text-field>

              <v-list three-line>
                <template v-for="(item, index) in filteredItems">
                  <v-list-tile
                    :key="index.displayInfo"
                    @click="showOnMap(item)"
                  >
                    <v-list-tile-content
                      ><div v-html="item.displayInfo"></div
                    ></v-list-tile-content>
                  </v-list-tile>
                  <v-divider
                    v-if="index + 1 < date_parcele_converted.length"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list>
            </v-card> -->
            <!-- <div v-for="(item, index) in date_parcele_converted" :key="index"> -->
            <v-card>
              <v-text-field
                v-model="search"
                class="mx-3"
                flat
                label="Search"
                prepend-inner-icon="search"
                @click:clear="clearSearch"
              ></v-text-field>
              <template v-for="(item, index) in filteredItems">
                <v-card-text
                  v-if="item.displayInfo !== ''"
                  :key="index.displayInfo"
                >
                  <div v-html="item.displayInfo"></div>
                  <div class="text-xs-center">
                    <v-btn text small class="primary" @click="showOnMap(item)"
                      >VIZUALIZARE</v-btn
                    >
                  </div>
                </v-card-text>
                <v-divider
                  v-if="
                    index + 1 < date_parcele_converted.length &&
                      item.displayInfo !== ''
                  "
                  :key="index"
                ></v-divider>
              </template>
            </v-card>
            <!-- </div> -->
          </div>
        </v-navigation-drawer>
      </v-flex>

      <v-flex :class="(changeSize(), changeVal)">
        <v-container ref="map" fluid class="App" />
      </v-flex>
    </v-layout>
  </div>
  <!-- <v-row no-gutters>
    <v-col ref="map"></v-col>
  </v-row> -->
  <!-- <div ref="map" class="map"></div> -->
</template>

<script>
import gmapsInit from '../utils/gmaps.js'
import ApiService from '../APIService.js'

export default {
  name: 'MapForm',
  props: {
    entityId: {
      type: String,
      required: true
    },
    showSearch: {
      type: Boolean,
      default: null
    },
    queryId: {
      type: String,
      default: null
    },
    // daca map form-ul nu este principal ci este aditional atunci o sa primeasca id-ul
    formId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      finalQueryId: this.queryId,
      infoWindows: [],
      categories: {},
      date_parcele: [],
      metadata: null,
      listBtn: false,
      changeVal: '',
      displayInfoArr: [],
      date_parcele_converted: [],
      map: {},
      arrEmpty: false,
      form: null,
      google: null,
      search: ''
    }
  },

  computed: {
    filteredItems() {
      return this.date_parcele_converted.filter((item) => {
        return item.displayInfo.toLowerCase().match(this.search.toLowerCase())
      })
    },
    displayInfo() {
      var arrNotEmpty = false
      this.date_parcele_converted.forEach((parcel) => {
        if (parcel.displayInfo !== '' && arrNotEmpty === false) {
          arrNotEmpty = true
        }
      })
      return arrNotEmpty
    }
  },
  async mounted() {
    // this.google = await gmapsInit()
    // this.map = new this.google.maps.Map(this.$refs.map)

    // this.map.setMapTypeId('satellite')
    // if (
    //   this.date_parcele_converted == null ||
    //   this.date_parcele_converted.length === 0
    // ) {
    //   this.map.setCenter({ lng: 26.0245986, lat: 44.4378044 })
    //   this.map.setZoom(14)
    //   return
    // }
    this.initMap()
  },
  created() {
    console.log('map form created')
    var promise
    if (this.formId == null) {
      promise = ApiService.getForm(this.entityId, 'map')
    } else {
      promise = ApiService.getFormById(this.formId)
    }
    promise.then((res) => {
      this.$emit('getMapTitle', res.data.title)
      this.form = res.data
      console.log('Fetched map form')
      if (this.finalQueryId == null) {
        if (this.queryId == null) {
          console.log('Pulling query for MapForm')
          this.finalQueryId = this.form.queryId || this.form.schema.queryId
        } else {
          this.finalQueryId = this.queryId
        }
      }
      this.metadata = this.form.schema
      this.initMap().then(() => {
        this.configureMap()
      })
    })
  },
  destroyed() {
    this.$emit('destroyedMap')
  },
  methods: {
    clearSearch() {
      this.search = ''
    },
    async refreshData() {
      if (this.finalQueryId != null) {
        this.date_parcele = await ApiService.getQueryData(this.finalQueryId)
          .then((res) => {
            console.log(
              `refreshing data for queryId: ${this.finalQueryId}, fetched: ${
                res.data.length
              }`
            )
            return res.data
          })
          .catch((err) => {
            console.log(
              'Error fecthing data from query: ' +
                this.finalQueryId +
                ' for map form. Err: ' +
                JSON.stringify(err)
            )
            return []
          })
      } else {
        console.log('Map form no query found!')
        this.date_parcele = await ApiService.getAllEntries(this.entityId)
          .then((res) => {
            if (res.status >= 200 && res.status <= 299) {
              return res.data
            } else {
              throw new Error(
                'API call failed: ' + res.status + ' ' + res.statusText
              )
            }
          })
          .catch((err) => {
            console.log(
              'Error fetching additional list form: ' + JSON.stringify(err)
            )
            return []
          })
      }
    },
    async initMap() {
      this.google = await gmapsInit()
      this.map = new this.google.maps.Map(this.$refs.map)

      this.map.setMapTypeId('satellite')
      if (
        this.date_parcele_converted == null ||
        this.date_parcele_converted.length === 0
      ) {
        this.map.setCenter({ lng: 26.0245986, lat: 44.4378044 })
        this.map.setZoom(14)
        return
      }
    },
    async configureMap() {
      console.log('Configuring map...')
      if (this.form == null) {
        console.log('MapForm not loaded')
      }

      await this.refreshData()
      // try {
      this.date_parcele_converted = []
      for (let i in this.date_parcele) {
        const parsedLine = this.parseLine(this.date_parcele[i])
        if (parsedLine != null) {
          this.date_parcele_converted.push(parsedLine)
        }
      }

      this.map.setMapTypeId('satellite')
      if (
        this.date_parcele_converted == null ||
        this.date_parcele_converted.length === 0
      ) {
        this.map.setCenter({ lng: 26.0245986, lat: 44.4378044 })
        this.map.setZoom(14)
        return
      }

      let lngCenter, latCenter
      if (Array.isArray(this.date_parcele_converted[0].coordinates[0])) {
        lngCenter = this.date_parcele_converted[0].coordinates[0][0].lng
        latCenter = this.date_parcele_converted[0].coordinates[0][0].lat
      } else {
        lngCenter = this.date_parcele_converted[0].coordinates[0].lng
        latCenter = this.date_parcele_converted[0].coordinates[0].lat
      }

      this.map.setCenter({ lng: lngCenter, lat: latCenter })

      this.map.setZoom(14)
      this.date_parcele_converted.forEach((parcel) => {
        var flightPath
        if (parcel.coordinates.length > 1) {
          flightPath = new this.google.maps.Polygon({
            paths: parcel.coordinates,
            geodesic: true,
            strokeColor: this.categories[parcel[this.metadata.groupingColumn]],
            strokeOpacity: 1.0,
            strokeWeight: 4,
            fillColor: this.categories[parcel[this.metadata.groupingColumn]],
            fillOpacity: 0.8
          })
        } else {
          flightPath = new this.google.maps.Marker({
            map: this.map,
            position: parcel.coordinates[0],
            title: 'Marker'
          })
        }

        var infowindow = new this.google.maps.InfoWindow({
          content: parcel.displayInfo,
          position: Array.isArray(parcel.coordinates[0])
            ? parcel.coordinates[0][0]
            : parcel.coordinates[0]
        })
        parcel.infowindow = infowindow

        this.infoWindows.push(infowindow)

        if (parcel.displayInfo !== '')
          this.displayInfoArr.push(parcel.displayInfo)

        this.google.maps.event.addListener(
          flightPath,
          'click',
          this.infoCallback(infowindow, this.map, this.infoWindows)
        )
        flightPath.setMap(this.map)
      })
      // } catch (error) {
      //   console.error(error)
      //   throw error
      // }
    },
    showOnMap(item) {
      this.map.setCenter({
        lng: item.coordinates[0].lng,
        lat: item.coordinates[0].lat
      })
      if (item.infowindow.content !== '') {
        for (let i in this.infoWindows) this.infoWindows[i].close(this.map)
        item.infowindow.open(this.map)
      }
    },
    changeSize() {
      if (this.listBtn === true) {
        this.changeVal = 'xs6 sm7 md9 lg10'
      } else if (this.displayInfo === false) {
        this.changeVal = 'xs12'
      } else {
        this.changeVal = 'xs11'
      }
      return this.changeVal
    },
    infoCallback(infowindow, map, infoWindows) {
      return function() {
        if (infowindow.content !== '') {
          for (let i in infoWindows) infoWindows[i].close(map)
          infowindow.open(map)
        }
      }
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    parseCoordinates(line) {
      var tempArray = []
      for (let i in line) {
        let twoCoordinates = line[i].split(' ')
        tempArray.push({
          lng: Number(twoCoordinates[0]),
          lat: Number(twoCoordinates[1])
        })
      }
      return tempArray
    },
    parseLine(line) {
      if (
        line == null ||
        line.geometrie == null ||
        line.geometrie.trim() === ''
      ) {
        return null
      }
      var date_parcela_converted = []

      if (line.geometrie[0] === '(') {
        line.geometrie = line.geometrie.substring(1)
      }
      if (line.geometrie[line.geometrie.length - 1] === ')')
        line.geometrie = line.geometrie.substring(0, line.geometrie.length - 1)
      var posBracket = line.geometrie.indexOf(')', 0)
      var endIndex = line.geometrie.length
      if (this.categories[line[this.metadata.groupingColumn]] == null) {
        this.categories[
          line[this.metadata.groupingColumn]
        ] = this.getRandomColor()
      }
      if (posBracket != -1) {
        var outerCoordinates = this.parseCoordinates(
          line.geometrie.substring(0, posBracket).split(',')
        )
        var innerCoordinates = this.parseCoordinates(
          line.geometrie.substring(posBracket + 3, endIndex).split(',')
        )
        date_parcela_converted = [outerCoordinates, innerCoordinates]
      } else {
        date_parcela_converted = this.parseCoordinates(
          line.geometrie.substring(0, endIndex).split(',')
        )
      }

      var splittedString = this.metadata.displayInfo.match(/\$[a-zA-Z0-9_]+/g)
      var displayInfo = this.metadata.displayInfo
      for (var index in splittedString) {
        displayInfo = displayInfo.replace(
          splittedString[index],
          line[splittedString[index].substring(1)]
        )
      }

      var returnedObj = line
      returnedObj.coordinates = date_parcela_converted
      returnedObj.displayInfo = displayInfo

      return returnedObj
    }
  }
}
</script>
<style>
.map {
  height: 100%;
}
.App {
  width: 100vw;
  height: 100vh;
  max-width: 100%;
}
</style>
